import React from "react";
import { Link } from "react-router-dom";

/**
 * BrandWordmark — single source of truth for the SkillConnect logo.
 *
 * Renders the official brand PNG (`/brand/skillconnect-logo.png`) on every
 * surface (navbar, sidebar, footer, install banner, etc.) so the logo is
 * identical everywhere. The PNG is the canonical asset the brand owner
 * supplied — do not crop, recolour, or substitute.
 *
 * Day/night handling lives in `index.css` under
 * `[data-theme="dark"] img[data-brand-logo="true"]` — wraps the logo in a
 * soft white pill in dark mode so the dark "Skill" wordmark stays legible.
 *
 * Props:
 *   size      – pixel HEIGHT of the logo (width is auto). default 36.
 *   to        – router target. pass `null` to render as a plain inline span.
 *   testId    – data-testid root. default "brand-wordmark".
 *   className – extra wrapper classes.
 */
export default function BrandWordmark({
  size = 36,
  to = "/",
  testId = "brand-wordmark",
  className = "",
}) {
  const img = (
    <img
      src="/brand/skillconnect-logo.png?v=8"
      alt="SkillConnect"
      data-brand-logo="true"
      data-testid={`${testId}-img`}
      draggable="false"
      className="block object-contain select-none transition-transform duration-500 hover:scale-105"
      style={{ height: size, width: "auto", maxWidth: "100%" }}
    />
  );

  if (!to) {
    return (
      <span className={`inline-flex items-center ${className}`} data-testid={testId}>
        {img}
      </span>
    );
  }
  return (
    <Link to={to} className={`inline-flex items-center ${className}`} aria-label="SkillConnect home" data-testid={testId}>
      {img}
    </Link>
  );
}
